import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import {store} from './store/store'
import router from "./router/router";
// import VueI18n from 'vue-i18n'
import i18n from './i18n'
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import Skeleton from 'vue-loading-skeleton';
import Toast from "vue-toastification";
import * as Sentry from "@sentry/vue";
import { initTheme } from "@/utils/theme";

import '../src/scss/app.scss'
import "vue-toastification/dist/index.css";
import '../src/scss/toast.scss'

// --- Register plugins BEFORE creating the root instance ---
Vue.use(Router)
// Vue.use(VueI18n)
Vue.use(VueBottomSheet);
Vue.use(Skeleton);

const toastOptions = {
    position: "top-center",
    timeout: 3000,
    closeButton: false,
    hideProgressBar: false,   // keep the bar mounted — it drives the timer (hidden via CSS opacity)
    icon: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    newestOnTop: true,
    // Default "Vue-Toastification__bounce" transition (reliable lifecycle +
    // auto-dismiss timer); its enter/leave keyframes are restyled in toast.scss
    // to the Dynamic-Island animation.
};
Vue.use(Toast, toastOptions);

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost"],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

Vue.config.productionTip = false;

// Resolve + apply the light/dark theme before mount (avoids a flash).
initTheme();

new Vue({
    el: "#app",
    render: h => h(App),
    store: store,
    i18n,
    router
})
